import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    minWidth: 120,
    width: '45%',
    margin: [theme.spacing(2), 0],
    height: 70,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.up('mobile')]: {
      height: 60,
    },
  },
  field: {
    height: 40,
  },
  adornment: {
    backgroundColor: '#ECEFF1',
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOptions/components/BidPage/components/AutoCalculation/components/BidFormValueField/useStyles.js